function htmlEncode(t) {
    return t ? $("<div/>").text(t).html() : ""
}

function is_touch_device() {
    return "ontouchstart" in window || navigator.maxTouchPoints
}

$(function() {
       // Function to handle cart popup
    function openCartPopup() {
        // Check if maximum quantity warning exists
        var maxQuantityWarning = $('p.warning.animated.bounceIn').filter(function() {
            return $(this).text().includes('maximum quantity');
        });
        
        // Only open cart popup if there's no maximum quantity warning
        if (maxQuantityWarning.length === 0) {
            var $cartContainer;
            if ($('header').is(':visible')) {
                $cartContainer = $('header .cart-container');
            }
            $cartContainer.addClass('popup-open');
        }
    }

    // Handle add to cart button click
    $('body').on('click', '.add_to_cart', function(e) {
        setTimeout(openCartPopup, 1000);

        var $button = $(this);
        var buttonText = $button.text().trim();

        if (buttonText === 'PROCEED TO CHECKOUT') {
            window.location.href = $button.data('cart-redirect');
        }
    });

    utils.enableDisclosure();
    var oldFlickityCreate = window.Flickity.prototype._create;
    window.Flickity.prototype._create = function() {
            var t = this;
            return this.element.addEventListener &&
                this.element.addEventListener("load",
                    function() {
                        t.onresize()
                    }, !0),
                this._create = oldFlickityCreate, oldFlickityCreate.apply(this, arguments)
        },
        imageFunctions.flickityIosFix(),
        objectFitImages(),
        header.loadMegaMenu(),
        header.init(),
        Shopify.theme_settings.enable_autocomplete &&
        searchAutocomplete.init(),
        utils.pageBannerCheck(),
        slideshow.init(),
        testimonial.init(),
        videoSection.init(),
        gallery.init(),
        videoFeature.setupVideoPlayer(),
        featuredPromotions.init(),
        featuredCollectionSection.init(),
        collectionSidebarFilter.init(),
        cart.init(),
        mapFunction.init(),
        productPage.init(),
        recentlyViewed.init(),
        (Currency.show_multiple_currencies || Currency.native_multi_currency) &&
        currencyConverter.init();
    var pathname = location.pathname,
        resizeTimeout;
    pathname.startsWith("/challenge") && $("html, body").animate({
        scrollTop: 0
    }, "slow");
    var beforeResizeWidth = $(window).width();
    window.addEventListener("resize", function(t) {
        resizeTimeout || (resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            var t = $(window).width();
            Shopify.media_queries.medium.matches && t !== beforeResizeWidth &&
                (cart.init(), header.unload(), header.init())
        }, 66))
    }, !1), $.fancybox.defaults.animationEffect = "fade", $.fancybox.defaults.transitionEffect = "fade", $.fancybox.defaults.hash = !1, $.fancybox.defaults.infobar = !1, $.fancybox.defaults.toolbar = !1, $.fancybox.defaults.arrows = !1, $.fancybox.defaults.loop = !0, $.fancybox.defaults.smallBtn = !0, $.fancybox.defaults.live = !1, $.fancybox.defaults.zoom = !1, $.fancybox.defaults.mobile.preventCaptionOverlap = !1, $.fancybox.defaults.mobile.toolbar = !0, $.fancybox.defaults.mobile.buttons = ["close"], $.fancybox.defaults.mobile.clickSlide = "close", $.fancybox.defaults.mobile.clickContent = "zoom", $.fancybox.defaults.afterLoad = function(t, e) {
        "image" == t.current.type && e.$content.wrapInner("<div class='fancybox-image-wrap'></div>"), t.group.length > 1 && e.$content.find(".fancybox-image-wrap").append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' + svgArrowSizeLeft + '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' + svgArrowSizeRight + "</span></a>")
    }, $('.lightbox[rel="gallery"]').fancybox();
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

    function getAspectRatio(t, e) {
        var i = t / e;
        return 0 == Math.abs(i - 1) ? "1:1" : Math.abs(i - 4 / 3) < Math.abs(i - 16 / 9) ? "4:3" : "16:9"
    }
    $videoIframes.each(function(t, e) {
        var i = $(e),
            a = i.attr("src");
        i.parents(".plyr__video-wrapper").length || i.parents(".lazyframe").length || i.wrap('<div class="lazyframe" data-ratio="' + getAspectRatio(i.attr("width"), i.attr("height")) + '" data-src="' + a + '"></div>')
    }), lazyframe(".lazyframe"), $(".shopify-policy__container").parent().prepend('<a name="pagecontent" id="pagecontent"></a>'), $(".shopify-policy__container").addClass("ten offset-by-three columns"), $(".shopify-policy__title").append('<div class="feature_divider"></div>');
    var currentValue = $(".search_form input[name='q']").val();
    $(".search_form input[name='q']").length > 0 && $(".search_form input[name='q']").val(currentValue.replace("*", "")), $("#sort-by").val($("#sort-by").data("default-sort")), $("body").on("change", "#sort-by", function() {
        quickFilter.init()
    }), $("body").on("change", "#tag_filter", function() {
        $("[data-option-filter] input").prop("checked", !1), quickFilter.init()
    }), $("body").on("change", "#blog_filter", function() {
        var t = $(this).val();
        window.location = t
    }), $("input, select, textarea").on("focus blur", function(t) {
        $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + ("blur" == t.type ? 10 : 1))
    }), $("body").on("change", "[data-option-filter] input", function() {
        quickFilter.init(), $("html, body").animate({
            scrollTop: $("#pagecontent").offset().top
        }, 500)
    }), $("body").on("click", "[data-reset-filters]", function() {
        collectionSidebarFilter.clearAllFilters()
    }), $("body").on("click", "[data-clear-filter]", function() {
        var t = $(this).parents(".filter-active-tag");
        collectionSidebarFilter.clearSelectedFilter(t)
    }), $("body").on("change", ".currencies", function(t) {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
    }), $("body").on("change", ".js-quick-shop select", function(t) {
        var e = $('.js-quick-shop select[name="id"]').val();
        e && globalQuickShopProduct && quickShop.updateVariant(e)
    }), Shopify.theme_settings.quick_shop_enabled && quickShop.init();
    var touchStartPos = 0;
    if ($(document).bind("touchstart", function(t) {
            touchStartPos = $(window).scrollTop()
        }).bind("touchend", function(t) {
            var e = touchStartPos - $(window).scrollTop();
            (e > 20 || e < -20) && t.preventDefault
        }), $("body").on("click", ".sidebar .parent-link--false", function(t) {
            t.preventDefault(), $menu = $(this).parent("li"), $menu.find(".menu-toggle").toggleClass("active"), $menu.find("ul").slideToggle()
        }), Shopify.theme_settings.newsletter_popup && newsletter_popup.init(), -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
            scrollTop: $("#new-comment").offset().top - 140
        }, "slow"), $("body").on("mouseenter", ".icon-search", function() {
            $(".search-terms").focus()
        }), $("body").on("click", ".icon-search", function() {
            $("input.search-terms").focus()
        }), $("body").on("click", ".search-submit", function() {
            $(this).parent().submit()
        }), Shopify.media_queries.large.matches && ($(".animate_right").waypoint(function() {
            $(this.element).addClass("animated fadeInRight")
        }, {
            offset: "70%"
        }), $(".animate_left").waypoint(function() {
            $(this.element).addClass("animated fadeInLeft")
        }, {
            offset: "70%"
        }), $(".animate_up").waypoint(function() {
            $(this.element).addClass("animated fadeInUp")
        }, {
            offset: "70%"
        }), $(".animate_down").waypoint(function() {
            $(this.element).addClass("animated fadeInDown")
        }, {
            offset: "70%"
        })), $(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({
            pageDots: usePageDots,
            imagesLoaded: !0,
            arrowShape: arrowSize,
            lazyLoad: 2
        }), utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list"), utils.createAccordion(".footer_menu", "h6", "ul"), utils.createAccordion(".footer_content", "h6", "div.toggle_content"), utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"), utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"), utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"), utils.initializeTabs(), utils.resizeActionButtons(), globalAccordions.init(), $(window).on("resize", function() {
            utils.resizeActionButtons()
        }), Shopify.media_queries.medium.matches && utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list"), $("body").on("click", ".menu-toggle", function(t) {
            $(this).next("ul").slideToggle(), $(this).toggleClass("active"), $(this).attr("aria-expanded", "true" == $(this).attr("aria-expanded") ? "false" : "true")
        }), Shopify.theme_settings.collection_swatches && Shopify.media_queries.large.matches && ($("body").on("mouseenter", ".collection_swatches", function() {
            $(".swatch span", $(this)).each(function() {
                -1 == $(this).data("image").indexOf("no-image") && ($("<img/>")[0].src = $(this).data("image"))
            })
        }), $("body").on("mouseenter", ".swatch span", function() {
            -1 == $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src", $(this).data("image")), $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset", $(this).data("image")))
        })), Shopify.theme_settings.display_tos_checkbox && $("body").on("click touchstart", ".cart_content .tos_label", function() {
            $(this).prev("input").prop("checked", !0)
        }), Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout ? $("body").on("click", ".tos_warning .action_button", function(t) {
            if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
                var e = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + "</p>";
                return 0 == $("p.warning").length && $(this).before(e), !1
            }
            Shopify.theme_settings.go_to_checkout || $("body").hasClass("cart") ? $(this).submit() : (t.preventDefault(), document.location.href = "/cart")
        }) : Shopify.theme_settings.go_to_checkout || $("body").on("click", ".cart_content .action_button", function(t) {
            t.preventDefault(), document.location.href = Shopify.routes.cart_url
        }), Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage(), $("[data-is-required]").length) {
        var $checkboxGroup = $(".contact-block--checkbox input");
        $checkboxGroup.prop("required", !0), $(".contact-block--checkbox [data-is-required] input").on("change", function() {
            $checkboxGroup.prop("required", !0), $checkboxGroup.is(":checked") && $checkboxGroup.prop("required", !1)
        })
    }

    function ajaxSubmitCart(t) {
        $cart = t, $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $cart.serialize(),
            success: function(t) {
                refreshCart(t)
            }
        })
    }

    function updateCartItemQuantity(t) {
        $.ajax({
            url: "/cart/change.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: {
                quantity: t.quantity,
                line: t.lineID
            },
            success: function(e) {
                var i = e.items,
                    a = t.lineID - 1,
                    o = t.parentCartForm.find("[data-variant-id]").length,
                    n = t.parentCartForm.find('[data-variant-id="' + t.variantID + '"] input'),
                    r = 0,
                    s = 0,
                    c = void 0 !== e.items[a] ? e.items[a].quantity : 0;
                if (n.length > 1 ? ($.each(n, function(t, e) {
                        r += parseInt($(e).val())
                    }), i.forEach(function(e) {
                        e.variant_id === t.variantID && (s += e.quantity)
                    })) : (r = parseInt(n.val()), s = void 0 !== e.items[a] ? e.items[a].quantity : 0), r > 0 && r > s)
                    if (items_left_text = 1 == s ? Shopify.translation.one_item_left : s < 5 ? Shopify.translation.five_item_left : s + " " + Shopify.translation.items_left_text, $(".warning--quantity").remove(), o < i.length) "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e);
                    else {
                        var l = '<p class="warning warning--quantity animated bounceIn">' + items_left_text + "</p>";
                        t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").parent().after(l), t.parentCartForm.find("[data-line-id='" + t.lineID + "'] input").val(c)
                    }
                else "cart-template" === t.parentCartForm.data("cart-form") ? t.parentCartForm.submit() : refreshCart(e)
            },
            error: function(e) {
                $('.mini-cart__item--content .js-change-quantity.is-disabled').removeClass('is-disabled')
                
                if (e.responseJSON && e.responseJSON.message) {
                    // Show alert but don't accumulate count
                    alert(e.responseJSON.message);
                    
                    // Find the cart item that triggered the error
                    var $cartItem = t.parentCartForm.find("[data-line-id='" + t.lineID + "']");
                    var $input = $cartItem.find('input[data-cart-quantity-input]');
                    
                    // Reset to original value or current cart value
                    var originalValue = $input.data('original-value') || t.quantity;
                    $input.val(originalValue);
                    
                    // Get the current cart state to update the UI correctly
                    $.getJSON('/cart.js', function(cart) {
                        refreshCart(cart);
                    });
                }
            },
        })
    }

    function refreshCartID() {
        for (var t = document.querySelectorAll(".cart__item"), e = 0; e < t.length; e++)
            for (var i = e + 1, a = t[e].querySelectorAll("[data-line-id]"), o = 0; o < a.length; o++) a[o].dataset.lineId = i
    }

    function refreshCart(t) {
        $(".cart_count").empty(), $cartBtn = $(".cart_count");
        var e = $cartBtn.text() || "0",
            a = "",
            o = "",
            n = "",
            r = "",
            s = $("[data-cart-form]"),
            c = !1,
            l = 0,
            d = 0;
        if (s.data("total-discount", t.total_discount), $cartBtn.text(e.replace(/[0-9]+/, t.item_count)), 0 == t.item_count) $(".js-empty-cart__message").removeClass("hidden"), s.addClass("hidden");
        else {
            $(".js-empty-cart__message").addClass("hidden"), s.removeClass("hidden");
            var p = 0,
                u = 0;
            $.each(t.items, function(t, e) {
                var o = e.discounts,
                    n = "";
                for (i = 0; i < o.length; i++) {
                    Shopify.formatMoney(o[i].amount, $("body").data("money-format"));
                    n = '<p class="notification-discount meta">' + o[i].title + "</p>"
                }
                var r = t + 1;
                if (a += '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' + r + '" data-variant-id="' + e.id + '">', 
                    e.image && (a += '<a href="' + e.url + '"><div class="cart_image"><img src="' + e.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + htmlEncode(e.title) + '" /></div></a>'), 
                    a += '<div class="mini-cart__item--content">',
                    a += '<div class="mini-cart__item__title">',
                    a += '<p style="margin: 0; color: #000; font-size: 16px; line-height: 21px; letter-spacing: 1.6px;">' + e.vendor + '</p>',
                    a += '<div class="item_title" style="display: flex; justify-content: space-between; gap: 10px; width: 100%;">',
                    a += '<a href="' + e.url + '" style="text-transform: uppercase; font-size: 12px; line-height: 18px; letter-spacing: 0.6px; width: 200px;">' + e.title, 
                    a += '</a>',
                    a += '<p style="color: #888; font-size: 12px; line-height: 18px; letter-spacing: 0.6px; margin: 0;">',
                    a += function() {
                        if (e.options_with_values) {
                            for (var i = 0; i < e.options_with_values.length; i++) {
                                if (e.options_with_values[i].name === 'Size') {
                                    return e.options_with_values[i].value === 'One Size' ? 'One Size' : 'Size ' + e.options_with_values[i].value;
                                }
                            }
                        }
                        return '';
                    }(),
                    a += '</p>',
                    a += '</div>',
                    a += '</div>',
                    e.properties && $.each(e.properties, function(t, e) {
                        e && (a += '<div class="line-item">' + t + ": " + e + " </div>")
                    }),
                    a += '<div style="display: flex; align-items: center; justify-content: space-between;">',
                    a += '<div class="left product-quantity-box">',
                    a += '<span class="ss-icon product-minus js-change-quantity" data-func="minus">',
                    a += e.quantity == 1 ? 
                    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">' +
                    '<path d="M9.09856 5.25L8.89663 10.5M6.10337 10.5L5.90144 5.25M11.7161 3.37783C11.9156 3.40796 12.1144 3.44019 12.3125 3.4745M11.7161 3.37783L11.0932 11.4757C11.0406 12.1595 10.4704 12.6875 9.78458 12.6875H5.21542C4.52959 12.6875 3.95938 12.1595 3.90678 11.4757L3.28387 3.37783M11.7161 3.37783C11.0474 3.27684 10.3709 3.1995 9.6875 3.14669M2.6875 3.4745C2.88558 3.44019 3.08438 3.40796 3.28387 3.37783M3.28387 3.37783C3.95262 3.27684 4.62912 3.1995 5.3125 3.14669M9.6875 3.14669V2.61228C9.6875 1.92431 9.15628 1.34997 8.46867 1.32797C8.14705 1.31768 7.82413 1.3125 7.5 1.3125C7.17587 1.3125 6.85295 1.31768 6.53133 1.32797C5.84372 1.34997 5.3125 1.92431 5.3125 2.61228V3.14669M9.6875 3.14669C8.96566 3.09091 8.23615 3.0625 7.5 3.0625C6.76385 3.0625 6.03434 3.09091 5.3125 3.14669" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '</svg>' :
                    '<svg class="cart-icon cart-icon--minus" xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">' +
                    '<g clip-path="url(#clip0_217_3693)">' +
                    '<path d="M1.5 6H11.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '</g>' +
                    '<defs>' +
                    '<clipPath id="clip0_217_3693)">' +
                    '<rect width="12" height="12" fill="white" transform="translate(0.5)"/>' +
                    '</clipPath>' +
                    '</defs>' +
                    '</svg>',
                    a += '</span>',
                    a += '<input type="number" min="0" size="2" class="quantity" name="updates[]" id="updates_' + e.id + '" value="' + e.quantity + '" data-cart-quantity-input="mini-cart" />',
                    a += '<span class="ss-icon product-plus js-change-quantity" data-func="plus">',
                    a += '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">',
                    a += '<g clip-path="url(#clip0_399_62676)">',
                    a += '<path d="M6.5 1V11M11.5 6L1.5 6" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
                    a += '</g>',
                    a += '<defs>',
                    a += '<clipPath id="clip0_399_62676">',
                    a += '<rect width="12" height="12" fill="white" transform="translate(0.5)"/>',
                    a += '</clipPath>',
                    a += '</defs>',
                    a += '</svg>',
                    a += '</span>',
                    a += '</div>',
                    $.ajax({
                        dataType: "json",
                        async: !1,
                        cache: !1,
                        url: "/products/" + e.handle + ".js",
                        success: function(t) {
                            if (t.variants) {
                                var i = t.variants;
                                if (i.length > 1)
                                    for (v = 0; v < i.length; v++)
                                        if (i[v].id == e.id) t = i[v]
                            }
                            t.compare_at_price ? t.compare_at_price > t.price && (c = !0, l = t.compare_at_price, d = t.price) : c = !1
                        }
                    }),
                    a += '<strong class="left price">',
                    1 == c) {
                    var s = Shopify.formatMoney(d, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(l, $("body").data("money-format")) + "</span>";
                    a += '<span class="money sale">' + s + "</strong>", u = (l - d) * e.quantity, p = u + p
                } else if (e.price > e.final_price) {
                    s = Shopify.formatMoney(e.final_price, $("body").data("money-format")) + ' </span><span class="money was_price">' + Shopify.formatMoney(e.price, $("body").data("money-format")) + "</span>";
                    a += '<span class="money sale">' + s + "</strong>"
                } else {
                    s = Shopify.formatMoney(e.price, $("body").data("money-format"));
                    a += '<span class="money">' + s + "</span></strong>"
                }
                
                if (e.price > e.final_price) {
                    a += n;
                }
                
                a += '</div>',
                a += '</div>',
                a += '<a href="' + Shopify.routes.cart_change_url + '?line=' + r + '&amp;quantity=0" class="cart__remove-btn" data-line-id="' + r + '" data-remove-item="mini-cart">',
                a += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">',
                a += '<path d="M6 14L14 6M6 6L14 14" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
                a += '</svg>',
                a += '</a>',
                a += '</li>'
            });
            var h = t.cart_level_discount_applications;
            for (i = 0; i < h.length; i++) {
                var f = Shopify.formatMoney(h[i].total_allocated_amount, $("body").data("money-format"));
                o += '<span class="cart_discounts--title">' + h[i].title + "</span>", o += '<span class="cart_discounts--price">', o += '-<span class="money">' + f + "</span></span>"
            }
            n += '<span class="right"><span class="money">' + Shopify.formatMoney(t.total_price, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_subtotal_text + "</span>", p += t.total_discount, r = Shopify.theme_settings.display_savings && p > 0 ? '<span class="right"><span class="money">' + Shopify.formatMoney(p, $("body").data("money-format")) + "</span></span><span>" + Shopify.translation.cart_savings_text + "</span>" : ""
        }
        $(".js-cart_items").html(a), $(".js-cart_discounts").html(o), $(".js-cart_subtotal").html(n), $(".js-cart_savings").html(r);
        
        // Update checkout button with current cart total
        if (Shopify.theme_settings.go_to_checkout) {
            var checkoutButtonText = "Checkout" + ' ' + Shopify.formatMoney(t.total_price, $("body").data("money-format"));
            $(".mini-cart__checkout .action_button.add_to_cart").html(checkoutButtonText);
            // Also update the button with name="checkout"
            $("button[name='checkout'].action_button.add_to_cart").html("Checkout" + ' ' + Shopify.formatMoney(t.total_price, $("body").data("money-format")));
        } else {
            var cartButtonText = "Go to cart";
            $(".mini-cart__checkout .action_button.add_to_cart").html(cartButtonText);
            // Also update any other cart buttons
            $("button.action_button.add_to_cart:not([name='checkout'])").html("Go to cart");
        }
        
        Currency.show_multiple_currencies && currencyConverter.convertCurrencies()
    }
    $(".maps").click(function() {
        $(".maps iframe").css("pointer-events", "auto")
    }), "load_more" == Shopify.theme_settings.pagination_type && enableLoadMoreProducts(), "infinite_scroll" == Shopify.theme_settings.pagination_type && enableInfiniteScroll(), "load_more" == Shopify.theme_settings.search_pagination_type && enableLoadMoreSearch(), "infinite_scroll" == Shopify.theme_settings.search_pagination_type && enableInfiniteSearchScroll(), $("body").on("change", "[data-cart-quantity-input]", function() {
        var t = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: $(this).val(),
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled"), updateCartItemQuantity(t)
    }), $("body").on("click", "[data-remove-item]", function(t) {
        t.preventDefault();
        var e = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
            quantity: 0,
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]")
        };
        e.$element.addClass("animated fadeOutLeft"), updateCartItemQuantity(e), "cart-template" === e.parentCartForm.data("cart-form") && (e.$element.find("input").val("0"), e.parentCartForm.submit()), "mini-cart" === e.parentCartForm.data("cart-form") && e.$element.find("input").val("0")
    }), "ajax" == Shopify.theme_settings.cart_action && $(document).on("click", ".ajax-submit", function(e) {
        e.preventDefault();
        var $addToCartForm = $(this).closest("form"),
            $addToCartBtn = $addToCartForm.find(".add_to_cart");
        
        // If button text is PROCEED TO CHECKOUT, don't run add.js
        if ($addToCartBtn.text() === 'PROCEED TO CHECKOUT') {
            return false;
        }
        
        return $("body").hasClass("cart") && $addToCartForm.submit(), $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: !1,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend: function() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success: function(t) {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active"), window.setTimeout(function() {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }, 1e3), $.ajax({
                    url: "/cart.js",
                    dataType: "json",
                    cache: !1,
                    success: function(t) {
                        let productButtons = document.querySelector('.product_section .button-row');
                        if(productButtons){
                            if(productButtons.querySelector('.action_button.add_to_cart')){
                                productButtons.querySelector('.action_button.add_to_cart').innerHTML = Shopify.translation.added_to_cart;
                            }
                        }
                        $(".warning").remove();
                        setTimeout(function() {
                            (refreshCart(t), $("body").hasClass("fancybox-active") && $.fancybox.close(), $("#header").is(":visible") ? $("#header .cart-container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart-container").addClass("active_link") : $(".top-bar .cart-container").addClass("active_link"), Shopify.media_queries.medium.matches) && ($(this).parent().hasClass("active_link"), $("body").addClass("blocked-scroll"))
                        }, 500)
                    }
                })
            },
            error: function(XMLHttpRequest) {
                var response = eval("(" + XMLHttpRequest.responseText + ")");
                response = response.description, $(".warning").remove();
                var warning = '<p class="warning animated bounceIn">' + response.replace("All 1 ", "All ") + "</p>";
                $addToCartForm.closest('.button-row').after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text(Shopify.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")
            }
        }), !1
    }), productPage.productSwatches()
}), Shopify.updateOptionsInSelector = function(t, e) {
    switch (t) {
        case 0:
            var i = "root";
            $(e + " .single-option-selector:eq(0)");
            break;
        case 1:
            i = $(e + " .single-option-selector:eq(0)").val(), $(e + " .single-option-selector:eq(1)");
            break;
        case 2:
            i = $(e + " .single-option-selector:eq(0)").val();
            i += " / " + $(e + " .single-option-selector:eq(1)").val();
            $(e + " .single-option-selector:eq(2)")
    }
    var a = Shopify.optionsMap[i];
    $(e + ' .swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        -1 !== $.inArray($(this).attr("data-value"), a) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
    })
}, Shopify.linkOptionSelectors = function(t, e) {
    Shopify.optionsMap = {};
    for (var i = 0; i < t.variants.length; i++) {
        var a = t.variants[i];
        if (a.available) {
            if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(a.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), t.options.length > 1) {
                var o = a.option1;
                Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(a.option2), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
            }
            if (3 === t.options.length) {
                o = a.option1 + " / " + a.option2;
                Shopify.optionsMap[o] = Shopify.optionsMap[o] || [], Shopify.optionsMap[o].push(a.option3), Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o])
            }
        }
    }
    Shopify.updateOptionsInSelector(0, e), t.options.length > 1 && Shopify.updateOptionsInSelector(1, e), 3 === t.options.length && Shopify.updateOptionsInSelector(2, e), $(e + " .single-option-selector:eq(0)").change(function() {
        return Shopify.updateOptionsInSelector(1, e), 3 === t.options.length && Shopify.updateOptionsInSelector(2, e), !0
    }), $(e + " .single-option-selector:eq(1)").change(function() {
        return 3 === t.options.length && Shopify.updateOptionsInSelector(2, e), !0
    })
};
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

function floatToString(t, e) {
    var i = t.toFixed(e).toString();
    return i.match(/^\.\d+/) ? "0" + i : i
}
if (void 0 === Shopify) var Shopify = {};
Shopify.each = function(t, e) {
    for (var i = 0; i < t.length; i++) e(t[i], i)
}, Shopify.map = function(t, e) {
    for (var i = [], a = 0; a < t.length; a++) i.push(e(t[a], a));
    return i
}, Shopify.arrayIncludes = function(t, e) {
    for (var i = 0; i < t.length; i++)
        if (t[i] == e) return !0;
    return !1
}, Shopify.uniq = function(t) {
    for (var e = [], i = 0; i < t.length; i++) Shopify.arrayIncludes(e, t[i]) || e.push(t[i]);
    return e
}, Shopify.isDefined = function(t) {
    return void 0 !== t
}, Shopify.getClass = function(t) {
    return Object.prototype.toString.call(t).slice(8, -1)
}, Shopify.extend = function(t, e) {
    function i() {}
    i.prototype = e.prototype, t.prototype = new i, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype
}, Shopify.locationSearch = function() {
    return window.location.search
}, Shopify.locationHash = function() {
    return window.location.hash
}, Shopify.replaceState = function(t) {
    window.history.replaceState({}, document.title, t)
}, Shopify.urlParam = function(t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "))
}, Shopify.newState = function(t, e) {
    return (Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e) + Shopify.locationHash()
}, Shopify.setParam = function(t, e) {
    Shopify.replaceState(Shopify.newState(t, e))
}, Shopify.Product = function(t) {
    Shopify.isDefined(t) && this.update(t)
}, Shopify.Product.prototype.update = function(t) {
    for (property in t) this[property] = t[property]
}, Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}, Shopify.Product.prototype.optionValues = function(t) {
    if (!Shopify.isDefined(this.variants)) return null;
    var e = Shopify.map(this.variants, function(e) {
        var i = "option" + (t + 1);
        return null == e[i] ? null : e[i]
    });
    return null == e[0] ? null : Shopify.uniq(e)
}, Shopify.Product.prototype.getVariant = function(t) {
    var e = null;
    return t.length != this.options.length ? e : (Shopify.each(this.variants, function(i) {
        for (var a = !0, o = 0; o < t.length; o++) {
            i["option" + (o + 1)] != t[o] && (a = !1)
        }
        return 1 == a ? void(e = i) : void 0
    }), e)
}, Shopify.Product.prototype.getVariantById = function(t) {
    for (var e = 0; e < this.variants.length; e++) {
        var i = this.variants[e];
        if (t == i.id) return i
    }
    return null
}, Shopify.money_format = "$", Shopify.formatMoney = function(t, e) {
    function i(t, e) {
        return void 0 === t ? e : t
    }

    function a(t, e, a, o) {
        if (e = i(e, 2), a = i(a, ","), o = i(o, "."), isNaN(t) || null == t) return 0;
        var n = (t = (t / 100).toFixed(e)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        r = e || this.money_format;
    switch (r.match(n)[1]) {
        case "amount":
            o = a(t, 2);
            break;
        case "amount_no_decimals":
            o = a(t, 0);
            break;
        case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",")
    }
    return r.replace(n, o)
}, Shopify.OptionSelectors = function(t, e) {
    return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function() {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
}, Shopify.OptionSelectors.prototype.initDropdown = function() {
    var t = {
        initialLoad: !0
    };
    if (!this.selectVariantFromDropdown(t)) {
        var e = this;
        setTimeout(function() {
            e.selectVariantFromParams(t) || e.fireOnChangeForFirstDropdown.call(e, t)
        })
    }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(t) {
    this.selectors[0].element.onchange(t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(t) {
    this.selectVariantFromParams(t) || this.selectVariantFromDropdown(t)
}, Shopify.OptionSelectors.prototype.replaceSelector = function(t) {
    var e = document.getElementById(t),
        i = e.parentNode;
    Shopify.each(this.buildSelectors(), function(t) {
        i.insertBefore(t, e)
    }), e.style.display = "none", this.variantIdField = e
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(t) {
    var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
    var i = e.value;
    return this.selectVariant(i, t)
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t)
}, Shopify.OptionSelectors.prototype.selectVariant = function(t, e) {
    var i = this.product.getVariantById(t);
    if (null == i) return !1;
    for (var a = 0; a < this.selectors.length; a++) {
        var o = this.selectors[a].element,
            n = i[o.getAttribute("data-option")];
        null != n && this.optionExistInSelect(o, n) && (o.value = n)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function(t, e) {
    for (var i = 0; i < t.options.length; i++)
        if (t.options[i].value == e) return !0
}, Shopify.OptionSelectors.prototype.insertSelectors = function(t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var i = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function(t) {
        i.appendChild(t)
    })
}, Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var t = 0; t < this.product.optionNames().length; t++) {
        var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
        e.element.disabled = !1, this.selectors.push(e)
    }
    var i = this.selectorDivClass,
        a = this.product.optionNames();
    return Shopify.map(this.selectors, function(t) {
        var e = document.createElement("div");
        if (e.setAttribute("class", i), a.length > 1) {
            var o = document.createElement("label");
            o.htmlFor = t.element.id, o.innerHTML = t.name, e.appendChild(o)
        }
        return e.appendChild(t.element), e
    })
}, Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
        var i = this.selectors[e].element.value;
        t.push(i)
    }
    return t
}, Shopify.OptionSelectors.prototype.updateSelectors = function(t, e) {
    var i = this.selectedValues(),
        a = this.product.getVariant(i);
    a ? (this.variantIdField.disabled = !1, this.variantIdField.value = a.id) : this.variantIdField.disabled = !0, this.onVariantSelected(a, this, e), null != this.historyState && this.historyState.onVariantChange(a, this, e)
}, Shopify.OptionSelectorsFromDOM = function(t, e) {
    var i = e.optionNames || [],
        a = e.priceFieldExists || !0,
        o = e.delimiter || "/",
        n = this.createProductFromSelector(t, i, a, o);
    e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e)
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(t, e, i, a) {
    if (!Shopify.isDefined(i)) i = !0;
    if (!Shopify.isDefined(a)) a = "/";
    var o = document.getElementById(t),
        n = o.childNodes,
        r = (o.parentNode, e.length),
        s = [];
    Shopify.each(n, function(t, o) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
            var n = t.innerHTML.split(new RegExp("\\s*\\" + a + "\\s*"));
            0 == e.length && (r = n.length - (i ? 1 : 0));
            var c = n.slice(0, r),
                l = i ? n[r] : "",
                d = (t.getAttribute("value"), {
                    available: !t.disabled,
                    id: parseFloat(t.value),
                    price: l,
                    option1: c[0],
                    option2: c[1],
                    option3: c[2]
                });
            s.push(d)
        }
    });
    var c = {
        variants: s
    };
    if (0 == e.length) {
        c.options = [];
        for (var l = 0; r > l; l++) c.options[l] = "option " + (l + 1)
    } else c.options = e;
    return c
}, Shopify.SingleOptionSelector = function(t, e, i, a) {
    this.multiSelector = t, this.values = a, this.index = e, this.name = i, this.element = document.createElement("select");
    for (var o = 0; o < a.length; o++) {
        var n = document.createElement("option");
        n.value = a[o], n.innerHTML = a[o], this.element.appendChild(n)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function(i, a) {
        a = a || {}, t.updateSelectors(e, a)
    }, !0
}, Shopify.Image = {
    preload: function(t, e) {
        for (var i = 0; i < t.length; i++) {
            var a = t[i];
            this.loadImage(this.getSizedImageUrl(a, e))
        }
    },
    loadImage: function(t) {
        (new Image).src = t
    },
    switchImage: function(t, e, i) {
        if (t && e) {
            var a = this.imageSize(e.src),
                o = this.getSizedImageUrl(t.src, a);
            i ? i(o, t, e) : e.src = o
        }
    },
    imageSize: function(t) {
        var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
        return null != e ? e[1] : null
    },
    getSizedImageUrl: function(t, e) {
        if (null == e) return t;
        if ("master" == e) return this.removeProtocol(t);
        var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != i) {
            var a = t.split(i[0]),
                o = i[0];
            return this.removeProtocol(a[0] + "_" + e + o)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    }
}, Shopify.OptionSelectors.HistoryState = function(t) {
    this.browserSupports() && this.register(t)
}, Shopify.OptionSelectors.HistoryState.prototype.register = function(t) {
    window.addEventListener("popstate", function(e) {
        t.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, i) {
    this.browserSupports() && (!t || i.initialLoad || i.popStateCall || Shopify.setParam("variant", t.id))
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
}, $(document).on("shopify:block:select", function(t) {
    var e = t.detail.blockId,
        i = $("#shopify-section-" + t.detail.sectionId);
    (i.hasClass("slideshow-section") || i.hasClass("testimonial-section")) && sliderBlock.select(e, i), i.hasClass("recommended-products-section") && $(".block__recommended_products").length && (productPage.unload(i), productPage.init()), i.hasClass("page-details-section") && ($(".map-section").length && mapFunction.init(), $(".recently-viewed__section").length && Shopify.theme_settings.collection_secondary_image && imageFunctions.showSecondaryImage()), i.hasClass("cart-section") && $(".block__featured_collection").length && featuredCollectionSection.init(), i.hasClass("product-template") && Shopify.theme_settings.enable_shopify_review_comments && $("#shopify-product-reviews").length >= 1 && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    }), utils.resizeActionButtons()
}), $(document).on("shopify:block:deselect", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    (e.hasClass("slideshow-section") || e.hasClass("testimonial-section")) && sliderBlock.deselect(e)
}), $(document).on("shopify:section:reorder", function(t) {
    utils.pageBannerCheck()
}), $(document).on("shopify:section:load", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    utils.pageBannerCheck(), utils.enableDisclosure(), Shopify.theme_settings.newsletter_popup && newsletter_popup.init(), e.hasClass("image-gallery-section") && gallery.init(e), e.hasClass("faq-section") && globalAccordions.init(), e.hasClass("cart-section") && (cart.init(), $(".block__featured_collection").length && featuredCollectionSection.init()), e.hasClass("featured-promotions-section") && featuredPromotions.init(), e.hasClass("slideshow-section") && slideshow.init(), Shopify.theme_settings.enable_autocomplete && e.hasClass("search-section") && searchAutocomplete.init(), e.hasClass("testimonial-section") && testimonial.init(), e.hasClass("featured-products-section") && (productPage.init(), videoFeature.init(), productPage.productSwatches(), Shopify.theme_settings.enable_shopify_review_comments && $(".shopify-product-reviews-badge").length && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    })), e.hasClass("map-section") && mapFunction.init(), e.hasClass("featured-collection-section") && (featuredCollectionSection.init(), videoFeature.init()), e.hasClass("video-section") && videoSection.init(), e.hasClass("product-template") && (productPage.init(), videoFeature.init(), productPage.productSwatches(), recentlyViewed.init(), Shopify.theme_settings.enable_shopify_review_comments && ($("#shopify-product-reviews").length || $(".shopify-product-reviews-badge").length) && SPR.$(document).ready(function() {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    })), e.hasClass("recommended-products-section") && productPage.init(), e.hasClass("recently-viewed-section") && recentlyViewed.init(), e.hasClass("article-template-section") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
        scrollTop: $("#new-comment").offset().top - 140
    }, "slow"), e.hasClass("collection-template-section") && (collectionSidebarFilter.init(), recentlyViewed.init()), e.hasClass("contact-section") && mapFunction.init(), e.hasClass("search-template-section") && (Shopify.theme_settings.enable_autocomplete && searchAutocomplete.init(), collectionSidebarFilter.init()), e.hasClass("header-section") && (header.init(), header.loadMegaMenu()), e.hasClass("mega-menu-section") && header.loadMegaMenu(), e.hasClass("page-details-section") && (featuredCollectionSection.init(), videoSection.init(), recentlyViewed.init(), $(".block__image_gallery").length && gallery.init()), e.hasClass("product-details-section") && (featuredCollectionSection.init(), videoSection.init(), mapFunction.init(), $(".block__image_gallery").length && gallery.init(), recentlyViewed.init(), productPage.init())
}), $(document).on("shopify:section:unload", function(t) {
    var e = $(t.target),
        i = $("#shopify-section-" + t.detail.sectionId);
    i.hasClass("header-section") && (header.unload(e), header.unloadMegaMenu()), i.hasClass("slideshow-section") && slideshow.unload(e), i.hasClass("testimonial-section") && testimonial.unload(e), i.hasClass("search-section") && searchAutocomplete.unload(e), i.hasClass("product-template") && productPage.unload(i), i.hasClass("featured-products-section") && productPage.unload(i), i.hasClass("mega-menu-section") && header.unloadMegaMenu()
}), $(document).on("shopify:section:select", function(t) {
    var e = $("#shopify-section-" + t.detail.sectionId);
    if (e.hasClass("mega-menu-section")) {
        var i = $(".header ." + t.detail.sectionId).data("dropdown");
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').trigger("mouseenter"), $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').parents("header").addClass("editor-hover--true"), header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
        }, 10)
    }
    e.hasClass("featured-collection-section") && (featuredCollectionSection.unload(e), featuredCollectionSection.init()), utils.pageBannerCheck();
    var a = document.createEvent("UIEvents");
    a.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(a)
}), $(document).on("shopify:section:deselect", function(t) {
    if ($("#shopify-section-" + t.detail.sectionId).hasClass("mega-menu-section")) {
        var e = $(".header ." + t.detail.sectionId).data("dropdown");
        $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').trigger("mouseout"), $('a.mega-menu-parent[data-dropdown-rel="' + e + '"]').parents("header").removeClass("editor-hover--true")
    }
}), $(document).ready(function() {
    $(".container").has(".designer-banner").css("max-width", "max-content")
}), $(".parent-link--false.shop-menu-item").addClass("active"), $(".parent-link--false:contains('SHOWROOM')").addClass("active");
